import React, {Fragment} from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import $ from 'jquery';
import lessonmenuicon from '../../images/icons/lessonmenuiconwhite.png';
import UserStorageUtil from '../../util/UserStorageUtil';

export default class ChooseGrade extends LoggedInPage {
	
	constructor(props) {
		super(props);

		this.accessId = (props.selectedProductOption && !isNaN(props.selectedProductOption.value)) ? Number(props.selectedProductOption.value) : 1;

		this.entlKey = this.getUser().getAccessMap()[this.accessId] || "PLP|REVISION|TAKE";

		this.prodLabel = this.rb(this.entlKey);

		this.state = {
			selectedGradeName : this.props.selectedGradeOption.label,
			selectedIndex : 0,
			entlKey: this.entlKey,
			selectedClassId: 0,
			selectedGradeId:0
		}
		
		this.LessonTestMaps = window.LessonTestMaps || {};
		this.countryCode = '';
	}
	
	getEntlKey(accessId){
		return this.getUser().getAccessMap()[accessId] || "PLP|REVISION|TAKE";
	}

	componentDidMount(){
		this.countryCode = this.getGeo() || 'IN';
		//console.warn("this.countryCode ",this.countryCode);
		var selectedlabel = this.props.selectedGradeOption.label.split(" ").join("").toLowerCase();
		$("."+selectedlabel).trigger("click");
	}
	getGradeLabel(element){
		let label = element.label;

		let gradeTxt = this.getLabelByBoard(element);
		if(gradeTxt && gradeTxt.length > 0){
			return gradeTxt;
		}else if(element && element.gradeDisplayName && element.gradeDisplayName.length > 0 && element.gradeDisplayName !== "null"){
			return this.rb(element.gradeDisplayName);
		}else if(element && element.classDescription && element.classDescription.length > 0 && element.classDescription !== "null"){
			return this.rb(element.classDescription);
		}else{
			gradeTxt = label.split(" ")[1];
			var preText = this.rb("class.prefix.choosegrade");
			var superTxt = "";
			if(parseInt(gradeTxt) == 1){
				superTxt = "st";
			}else if(parseInt(gradeTxt) == 2){
				superTxt = "nd";
			}else if(parseInt(gradeTxt) == 3){
				superTxt = "rd";
			}else if(!isNaN(parseInt(gradeTxt))){
				superTxt = "th";
			}else{
				if(!(gradeTxt && gradeTxt.length > 0)){
					if(element.gradeId && element.gradeDisplayName && element.gradeDisplayName.length > 0){
						gradeTxt = element.gradeDisplayName;
					}else{
						gradeTxt = element.label;
					}

					return gradeTxt;
				}

				return (preText+gradeTxt);
			}
		}

		return (gradeTxt+"<sup>"+superTxt+"</sup>");
	}

	getLabelByBoard(element){
		let board = (element && element.board) ? element.board : null;

		const labelFieldsForBoard = (board && window.choose_grade_label_fields_for_boards && window.choose_grade_label_fields_for_boards[board]) ? window.choose_grade_label_fields_for_boards[board] : null;

		if(labelFieldsForBoard != null){
			return this.rb(element[labelFieldsForBoard[0]]);
		}else if(board && board.toUpperCase() === "RSA"){
			if(element && element.classDescription && element.classDescription.length > 0){
				return this.rb(element.classDescription);
			}else if(element && element.className && element.className.length > 0){
				return this.rb(element.className);
			}			

		}

		return null;
	}

	gradeClick(event){
		$(".gradeBox").removeClass("selected");
		$(event.currentTarget).addClass("selected");		 
		this.setState({selectedGradeName:$(event.currentTarget).attr("data-label"),selectedIndex:$(event.currentTarget).attr("data-index"),selectedClassId:$(event.currentTarget).attr("data-classid"),selectedGradeId:$(event.currentTarget).attr("data-gradeid")});
	}

	gradeDirectClick(event){
		$(".gradeBox").removeClass("selected");
		$(event.currentTarget).addClass("selected");		 
		this.setState({selectedGradeName:$(event.currentTarget).attr("data-label"),selectedIndex:$(event.currentTarget).attr("data-index"),selectedClassId:$(event.currentTarget).attr("data-classid"),selectedGradeId:$(event.currentTarget).attr("data-gradeid")},
		(
			() => {
				this.gradeSelected(event);
			}
		));
	}

	getIconForContent(contentKey){
		if(contentKey === "LessonsMapped"){
			return (<span className="topicmapLessons">
				<img className="material-icons mxwidthinherit" src={lessonmenuicon} alt="Animated Lessons icon" />
				</span>);
			}else if(contentKey === "SolvedExamplesGameQuiz"){
				return (<span className="topicmaptests">
				<i className="material-icons" role="img" aria-label="Puzzles and activites icon">extension</i>
				</span>);
			}else if(contentKey === "DiagnosticTests"){
				return (<span className="topicmaptests">
				<i className="material-icons" role="img" aria-label="Puzzles and activites icon">assignment</i>
				</span>);
			}else{
				return (<span className="topicmaptests">
				<i className="material-icons" role="img" aria-label="Puzzles and activites icon">assignment</i>
				</span>);
			}

		}
		/**
		* IMPORTANT: Content details that need to be shown in grade box.
		* contentKeys - list of keys for the content. For example: DiagnosticTests, LessonsMapped, SolvedExamplesGameQuiz
		* FUnction will check either gdname or classId
		*/
		getContentDetails(gdname, classId){
			let me = this;
			let authProviderId = this.getUser().getAuthProviderId();
			let entlKey = this.entlKey;
			let contentKeys = [];
			let classSelectkey = null;

			let content_keys_by_entlkey = (entlKey && window.chooseGradeContent_entl && window.chooseGradeContent_entl[entlKey]) ?  window.chooseGradeContent_entl[entlKey] : null;
			let content_keys_by_authProviderId = (authProviderId && window.chooseGradeContent_authprovider && window.chooseGradeContent_authprovider[authProviderId])? window.chooseGradeContent_authprovider[authProviderId] : null;

			if(classId && this.LessonTestMaps[classId]){
				contentKeys = Object.keys(this.LessonTestMaps[classId]);
				classSelectkey = classId;
			}else if(gdname && this.LessonTestMaps[gdname]){
				contentKeys = Object.keys(this.LessonTestMaps[gdname]);
				classSelectkey = gdname;
			}

			if(classSelectkey && this.LessonTestMaps[classSelectkey] && entlKey && contentKeys && contentKeys.length > 0){
				let validContentKeys = [];
				for(let i=0; i < contentKeys.length; i++){
					let menuAllowed = true;

					if(content_keys_by_authProviderId && content_keys_by_authProviderId.length > 0){
						//Check for Lumos suppression
						menuAllowed = (menuAllowed && content_keys_by_authProviderId.indexOf(contentKeys[i]) > -1);
					}

					if(content_keys_by_entlkey && content_keys_by_entlkey.length > 0 ){
					//Check for entlKey
					menuAllowed = (menuAllowed && content_keys_by_entlkey.indexOf(contentKeys[i]) > -1);

				}else if(!isNaN(me.LessonTestMaps[classSelectkey][contentKeys[i]]) && me.LessonTestMaps[classSelectkey][contentKeys[i]] > 0){
					menuAllowed = true;
				}

				if(menuAllowed){
					validContentKeys.push(contentKeys[i]);
				}
			}
			if(validContentKeys && validContentKeys.length > 0){
				return validContentKeys.map((contentKey, idx) => {
					if(contentKey && !isNaN(me.LessonTestMaps[classSelectkey][contentKey])){
						let dividerCls = "";
						let columnWidth = Math.floor(12 / validContentKeys.length) || 6;
						if(idx < validContentKeys.length - 1){
							dividerCls = " clearfix greyborderright";
						}else{
							dividerCls = " clearfix ";
						}

						return(
							<div className={"col-sm-"+columnWidth+" norightpadding "+ dividerCls} key={contentKey}>
							<div className="row">
							<div className="col-4 pt-10 text-right norightpadding">
							{me.getIconForContent(contentKey)}
							</div>
							<div className="col-8 pl-20 norightpadding">
							<div><strong>{me.LessonTestMaps[classSelectkey][contentKey]}</strong></div>
							<div>{me.rb(entlKey+"-"+contentKey)}</div>										
							</div>
							</div>
							</div>
							)
						}					
					});		

				}
			}
		}

		getGradeContent(){
			let userObj = UserStorageUtil.getStoredSessionItem("USER_DETAILS");
			let authProviderId = (userObj && userObj.authProviderId) ? userObj.authProviderId : 0;

			if(this.state.entlKey == "")
			{
				return;
			}
			let classArr = this.props.gradeArr.filter(obj=>obj.label==this.state.selectedGradeName);

			let classId = (classArr && classArr.length>0 && !isNaN(classArr[0].value)) ? Number(classArr[0].value) : 0;


			if(this.props.gradeProductMap[classId] && this.props.gradeProductMap[classId].length > 0){
				this.accessId = this.props.gradeProductMap[classId][0];
				this.entlKey = this.getEntlKey(this.props.gradeProductMap[classId][0]);
			}

			var productName = this.rb(this.entlKey);
			var producticon = "";
			var productclass = "";

			if(this.entlKey === "PLP|LESSON|VIEW"){
				producticon = "../img/e1.png";
				productclass = "lessons"
			}else if(this.entlKey === "PLP|TEST|TAKE"){
				producticon = "../img/e2.png";
				productclass = "cbse"
			}else if(this.entlKey === "TCHR|LESSON|VIEW"){
				producticon = "../img/e1.png";
				productclass = "lessons"
			}else{
				producticon = "../img/e3.png";
				productclass = "plp"
			}

			return(
				<div className="gradeContentBox col-lg-9 col-md-10 col-sm-12 col-12 mx-auto">
				<div className="mt-20"><img className={"gradeiconbox "+productclass} src={producticon} alt="" /></div>
				<div className="mt-20"><h4>{productName} for {this.state.selectedGradeName}</h4></div>
				<hr />
				<div>
				{(() => {
					var gdname = (this.state.selectedGradeName) ? this.state.selectedGradeName.split(" ").join("").toLowerCase() : "";

					if(parseInt(this.state.selectedGradeId) === 0){
						return(
						<div className="text-center ">
						<div className="row col-12 mx-auto text-left topicmapinforow">
						{this.getContentDetails(gdname, classId)}
						</div>
						</div>
						);
					}				

				})()}
				</div>
				</div>
				);
		}

		gradeSelected = () => {
			if(typeof this.props.gradeChangefromChooseGrade === 'function'){
				this.props.gradeChangefromChooseGrade(this.state.selectedIndex, this.accessId, this.entlKey);
			}
		}

		getArrayListSet = () => {
			let subjectSet = new Set();
			const sorter = window.choose_grade_sorter[this.getGeo()] || window.choose_grade_sorter["ALL"];
			let sortedArr = this.props.gradeArr;
			sortedArr = (sorter.order === "desc") ? sortedArr.reverse() : sortedArr;
			for(let i=0;i<sortedArr.length;i++){
				subjectSet.add(sortedArr[i].subject)
			}
			//console.warn("subjectSet ",subjectSet);
			return subjectSet;
		}

		makeSubjectBasedTree(subjSet,sortedArr){
			let subjectBasedArr = {};
			let subj = 0;
			let subjectSet = Array.from(subjSet);
			while(subj < subjectSet.length){
				for(let i=0;i<sortedArr.length;i++){
					if(i===0){
						subjectBasedArr[subjectSet[subj]] = [];
					}
					sortedArr[i].index = i;
					if(sortedArr[i].subject === subjectSet[subj]){
						subjectBasedArr[subjectSet[subj]].push(sortedArr[i]);
					}
				}
				//console.warn("subjectBasedArr ",subjectBasedArr," : ",sortedArr);
				subj++;
			}
			return subjectBasedArr;
		}

		getSubjectArrayList = () => {
			let me=this;
			let tempGradeArr = [];
			
			let sortedArr = this.props.gradeArr;
	
			const sorter = window.choose_grade_sorter[this.getGeo()] || window.choose_grade_sorter["ALL"];


			if(sorter && sorter.enabled){
				const sortingField = sorter.field;

				if(sortingField && sortedArr && sortedArr.length > 0 && sortedArr[0][sortingField]){
					const sortingType = sorter.type || (!isNaN(sortedArr[0][sortingField]) ? "number" : typeof me.props.gradeArr[0][sortingField]);

					sortedArr.sort((a,b) => {
						if(sortingType === "number"){
							return a[sortingField] - b[sortingField];
						}else if(sortingType === "string"){
							if(a[sortingField] && b[sortingField]){
								if(a[sortingField].toLowerCase() < b[sortingField].toLowerCase()){
									return -1;
								}else if(a[sortingField].toLowerCase() > b[sortingField].toLowerCase()){
									return 1;
								}
							}
						}

						return 0;					
					})
				}

				sortedArr = (sorter.order === "desc") ? sortedArr.reverse() : sortedArr;
			}
	
			let subjectSet = this.getArrayListSet();
			let gradeMapList = this.makeSubjectBasedTree(subjectSet,sortedArr);
			let topicTitle = Array.from(subjectSet);
			let wholeSubject = Object.values(gradeMapList);
			let selectedIndex = this.state.selectedIndex;
			
			/* which is hot coded for now */
			
			let subjectBasedUI = window.chooseGradeBasedonSubject || [];
			let willShowSubject = (subjectBasedUI.indexOf(this.countryCode) > -1 ) ? true : false;

			if(willShowSubject && (topicTitle.length>0) && wholeSubject.length>0){
				this.getArrayListSet();
				return(
					<Fragment>
					<div className="text-center mt-30"> <h3>{this.rb("select.your.class")}</h3> </div>
	
					<div className="text-center col-12 col-sm-12 col-md-10 col-lg-10 mx-auto mt-30 grade-only">
					{
						wholeSubject.map((sortedSub,valIndex) => {
							
							return(
									<div key={valIndex}>
										<p className="subtitle fancy"><span>{topicTitle[valIndex]}</span></p>
										{
												sortedSub.map((element,index) => {
													let addClass = (element.index == selectedIndex) ? " selected": '';
													//console.warn("sortedSub ",element.index," : ",selectedIndex);
													if(element && element.gradeId){
														if(!~tempGradeArr.indexOf(element.gradeId)){
															tempGradeArr.push(element.gradeId);
															return(			        		
																<div key={index} className={"gradeBox "+element.label.split(" ").join("").toLowerCase()+addClass} data-ga={"Post login - Choose your class - "+element.label} data-value={element.value} data-label={element.label} data-index={element.index} data-gradeid={element.gradeId} data-classid={element.classId} onClick={this.gradeDirectClick.bind(this)}><h3>{ReactHtmlParser(this.getGradeLabel(element))}</h3></div>
																);		
														}							
													}else{
														return(			        		
															<div key={index} className={"gradeBox "+element.label.split(" ").join("").toLowerCase()+addClass} data-ga={"Post login - Choose your class - "+element.label} data-value={element.value} data-label={element.label} data-index={element.index} data-gradeid={element.gradeId} data-classid={element.classId} onClick={this.gradeDirectClick.bind(this)}><h3>{ReactHtmlParser(this.getGradeLabel(element))}</h3></div>
															);			        		    	
													}	
												})
											}
									</div>
							)
							
						})
					}
					</div>
					</Fragment>
				)
			}else{
				return (
					<Fragment>
					<div className="text-center mt-30"> <h3>{this.rb("select.your.class")}</h3> </div>
	
					<div className="text-center col-12 col-sm-12 col-md-10 col-lg-10 mx-auto mt-30">
					{
						sortedArr.map((element,index) => {
							if(element && element.gradeId){
								if(!~tempGradeArr.indexOf(element.gradeId)){
									tempGradeArr.push(element.gradeId);
									return(			        		
										<div key={index} className={"gradeBox "+element.label.split(" ").join("").toLowerCase()} data-ga={"Post login - Choose your class - "+element.label} data-value={element.value} data-label={element.label} data-index={index} data-gradeid={element.gradeId} data-classid={element.classId} onClick={this.gradeClick.bind(this)}><h3>{ReactHtmlParser(this.getGradeLabel(element))}</h3></div>
										);		
								}							
							}else{
								return(			        		
									<div key={index} className={"gradeBox "+element.label.split(" ").join("").toLowerCase()} data-ga={"Post login - Choose your class - "+element.label} data-value={element.value} data-label={element.label} data-index={index} data-gradeid={element.gradeId} data-classid={element.classId} onClick={this.gradeClick.bind(this)}><h3>{ReactHtmlParser(this.getGradeLabel(element))}</h3></div>
									);			        		    	
							}	
						})
					}
					</div>
	
					<div className="text-center mt-30">
					{this.getGradeContent()}
					</div>
	
					<div className="text-center mt-30">
	
					<button className="submitButton signup signupButton" onClick={this.gradeSelected.bind(this)} data-ga={"Post login - Choose your class - "+this.state.selectedGradeName+" - Start Learning"} >{this.rb("register.startlearning")}</button>
	
					</div>
					</Fragment>
					);
			}
		}

		render() {
			const me = this;
			//console.warn("sorted lalala ::", sortedArr);
			return(
				<div id="choosegrade">
					{
						this.getSubjectArrayList()
					}
				</div>
			)
		}
	}


// WEBPACK FOOTER //
// ./src/views/common/ChooseGrade.js